(() => {
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointerQuery = window.matchMedia('(pointer: fine)');

  const initHero = (hero) => {
    if (hero.dataset.hmMotionReady === 'true') return;
    hero.dataset.hmMotionReady = 'true';

    const layers = Array.from(hero.querySelectorAll('[data-hm-depth]'));
    let frame = null;
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;

    const render = () => {
      currentX += (targetX - currentX) * 0.09;
      currentY += (targetY - currentY) * 0.09;

      layers.forEach((layer) => {
        const depth = Number(layer.dataset.hmDepth || 0);
        layer.style.setProperty('--hm-parallax-x', `${(currentX * depth).toFixed(2)}px`);
        layer.style.setProperty('--hm-parallax-y', `${(currentY * depth).toFixed(2)}px`);
      });

      if (Math.abs(targetX - currentX) > 0.05 || Math.abs(targetY - currentY) > 0.05) {
        frame = window.requestAnimationFrame(render);
      } else {
        frame = null;
      }
    };

    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(render);
    };

    const reset = () => {
      targetX = 0;
      targetY = 0;
      schedule();
    };

    hero.addEventListener('pointermove', (event) => {
      if (motionQuery.matches || !finePointerQuery.matches) return;
      const rect = hero.getBoundingClientRect();
      targetX = ((event.clientX - rect.left) / rect.width - 0.5) * 28;
      targetY = ((event.clientY - rect.top) / rect.height - 0.5) * 22;
      schedule();
    }, { passive: true });

    hero.addEventListener('pointerleave', reset, { passive: true });
    motionQuery.addEventListener?.('change', reset);
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-hm-motion]').forEach(initHero);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
